import { type LucideIcon } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * Tab placeholder para módulos que aún no se construyen (contratos, facturas, pagos, etc.).
 * El endpoint del backend ya existe — solo falta la UI específica por fase.
 */
export function ComingInPhaseTab({
  icon: Icon,
  title,
  phase,
  description,
}: {
  icon: LucideIcon;
  title: string;
  phase: string;
  description?: string;
}) {
  return (
    <div className="flex items-center justify-center py-10">
      <Card className="max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-2 flex h-10 w-10 items-center justify-center rounded-lg bg-muted text-muted-foreground">
            <Icon size={18} />
          </div>
          <CardTitle>{title}</CardTitle>
          <CardDescription>Llega en {phase}</CardDescription>
        </CardHeader>
        <CardContent className="text-center text-xs text-muted-foreground">
          {description ??
            "El backend ya expone los endpoints — solo falta conectar la UI específica de esta pestaña."}
        </CardContent>
      </Card>
    </div>
  );
}
